const verticals = {
   retail: {
      name: "retail",
      esltag: {
         upload: true,
         esltags: 'ESL Tags',
         esltag: 'ESL Tag',
         list: 'ESL Tags List',
         add: 'Add ESL Tag',
         detail: 'ESL Tag Detail',
         autoScan: 'Auto Scan ESL',
      },
      product: {
         products: 'Products',
         list: 'Products List',
         add: 'Add Product',
         detail: 'Product Detail',
         id: 'ID',
         name: 'Product Name',
         store: 'Store',
         price: 'Price',
         storeName: 'Store Name',
         footNote: 'Footnote',
      },
      binding: {
         binding: 'Display Sync',
         bindingList: 'Display Sync List',
         updateTags: 'Update Tags',
         tagId: 'Device Tag ID',
         lot: 'Product Name',
         update: 'Update Tag',
      },
      dash: {
         totalTags: 'Total ESL Tags',
      },
   },
   mfg: {
      name: "mfg",
      esltag: {
         upload: false,
         esltags: 'Display (H)',
         esltag: 'Display Tag',
         list: 'Display List',
         add: 'Add Display',
         detail: 'Display Detail',
         autoScan: 'Auto Scan',
      },
      product: {
         products: 'Update Display (H)',
         list: 'Display Info',
         add: 'Add Product',
         detail: 'Product Detail',
         id: 'Part Number',
         name: 'Field 2',
         store: 'Site',
         price: 'Price',
         storeName: 'Site Name',
         footNote: "Today's Date (DD/MM/YYYY)",
      },
      binding: {
         binding: 'Display Sync',
         bindingList: 'Display Sync List',
         updateTags: 'Update Tags',
         tagId: 'Display ID',
         lot: 'Field 2',
         update: 'Preview Update',
      },
      dash: {
         totalTags: 'Total Tags',
      },
   },
   display: {
      name: "display",
      esltag: {
         upload: false,
         esltags: 'Display (H)',
         esltag: 'Display Tag',
         list: 'Display List',
         add: 'Add Display',
         detail: 'Display Detail',
         autoScan: 'Auto Scan',
      },

      product: {
         products: 'Update Display (H)',
         list: 'Update Info',
         add: 'Add Product',
         detail: 'Product Detail',

         id: 'Field 1',
         name: 'Field 2',
         store: 'Site',
         price: 'Price',
         storeName: 'Store Name',
         footNote: 'Comment(s)',
      },

      binding: {
         binding: 'Display Sync',
         bindingList: 'Display Sync List',
         updateTags: 'Update Tags',
         tagId: 'Display ID',
         lot: 'Field 2',
         update: 'Preview Update',
      },

      dash: {
         totalTags: 'Total Tags',
      },
   }
}

var names = {}

let vertical = localStorage.getItem("vertical")
if (!vertical) {
   vertical = 'display'
}
names = verticals[vertical]
names.env = vertical

export default names